export const maskIBAN = {
    name: 'IBAN',
    description: "Mask IBAN numbers e.g. 'NL39RABO0300065264', 'NL39 RABO 0300 0652 64'",
    exceptions: [],
    filterRegex: /\b[a-zA-Z]{2}[ ]?[0-9]{2}[ ]?[a-zA-Z]{4}[ ]?[0-9]{4}[ ]?[0-9]{4}[ ]?[0-9]{2}?\b/g,
};
